import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import * as actions from "../Store/_redux/LeaveStore/leaveAction";
import { useEffect } from "react";

function DownloadButton() {
  const handleDownload = () => {
    const element = document.getElementById("pdf-container");
    if (element) {
      const opt = {
        margin: [5, 5, 5, 5],
        filename: "izin-formu.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 1.4, useCORS: true, scrollY: 0 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };
      html2pdf().set(opt).from(element).save();
    }
  };
  return (
    <button
      onClick={handleDownload}
      className="px-5 py-2 bg-[#2563EB] text-white rounded-md font-medium hover:bg-[#1E40AF] transition-colors duration-200 text-sm shadow-sm"
    >
      PDF olarak indir
    </button>
  );
}

function Details() {
  const navigate = useNavigate();
  const location = useLocation();
  const productId = location.pathname.split("/")[2];
  const leaves = useSelector((state) => state.leave?.leaves);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth.loginUser);

  useEffect(() => {
    dispatch(actions.getLeave(auth));
  }, []);

  const formLeave = leaves?.find(
    (form) => form.id === productId || form._id === productId
  ) || { owner: {} };

  if (!formLeave || !formLeave.owner) {
    return (
      <div className="w-full text-center py-10 text-sm text-gray-600">
        İzin formu bilgileri yükleniyor...
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-center justify-center text-[10px] tracking-wider bg-white py-6">
      {/* Üst Geri Dön Butonu */}
      <div className="w-[794px] max-w-full px-5 flex justify-start items-center print:hidden mb-3">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 transition-colors border border-gray-200 shadow-sm"
        >
          <ArrowLeft size={16} />
          Geri Dön
        </button>
      </div>

      <div
        id="pdf-container"
        className="w-[794px] bg-white text-[10px] font-arial font-[300] p-5 mx-auto"
      >
        <table className="w-full max-w-[600px] mt-7 mx-auto border-collapse border border-black">
          <tbody>
            <tr>
              <td className="w-[30%] text-sm font-arial-gd h-8 font-bold">FİRMA UNVANI :</td>
              <td className="border-l w-[70%] border-black">
                <span className="font-arial">Pavza Yazılım Bilişim Teknolojileri A.Ş.</span>
              </td>
            </tr>
            <tr>
              <td className="text-sm h-12 font-arial-gd font-bold">ADRESİ :</td>
              <td className="border-l border-black">
                <span className="font-arial">
                  Pavza Yazılım, Ostim OSB Mahallesi 100. Yıl Bulvarı No:55/E14 Yenimahalle / Ankara 06374
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="border border-black w-full max-w-[600px] mt-5 pb-5 mx-auto flex flex-col justify-center">
          <h1 className="text-center text-[16px] font-arial-gd underline py-5 tracking-widest font-bold">
            İZİN FORMU
          </h1>
          <table className="w-full max-w-[600px] mx-auto border-collapse border border-black">
            <tbody>
              <tr>
                <td className="w-[35%] font-bold">TC Kimlik No :</td>
                <td className="border-l border-black">{formLeave?.owner?.tc || "-"}</td>
              </tr>
              <tr>
                <td className="font-bold">Adı Soyadı :</td>
                <td className="border-l border-black">
                  {formLeave?.owner?.name || ""} {formLeave?.owner?.surname || ""}
                </td>
              </tr>
              <tr>
                <td className="font-bold">İzin Başlangıç Tarihi :</td>
                <td className="border-l border-black">
                  {formLeave.startDate
                    ? `${formLeave.startDate.substring(8, 10)}/${formLeave.startDate.substring(5, 7)}/${formLeave.startDate.substring(0, 4)}`
                    : "-"}
                </td>
              </tr>
              <tr>
                <td className="font-bold">İzin Bitiş (İşbaşı) Tarihi :</td>
                <td className="border-l border-black">
                  {formLeave.finishDate
                    ? `${formLeave.finishDate.substring(8, 10)}/${formLeave.finishDate.substring(5, 7)}/${formLeave.finishDate.substring(0, 4)}`
                    : "-"}
                </td>
              </tr>
              <tr>
                <td className="font-bold">İzin Gün Sayısı :</td>
                <td className="border-l border-black">
                  {formLeave?.isHalfDay && formLeave?.totalDate <= 1 && "Yarım"}
                  {formLeave?.isHalfDay && formLeave?.totalDate > 1 && `${formLeave?.totalDate}.5`}
                  {formLeave?.isHalfDay === false && `${formLeave?.totalDate || "-"}`}
                </td>
              </tr>
              <tr>
                <td className="font-bold">İzin İstek Sebebi :</td>
                <td className="border-l border-black">{formLeave?.leavesType || "-"}</td>
              </tr>
              <tr>
                <td className="px-1 indent-8" colSpan="2">
                  Yukarıda belirtilen sebepten dolayı{" "}
                  {formLeave.startDate ? `${formLeave.startDate.substring(8, 10)}/${formLeave.startDate.substring(5, 7)}/${formLeave.startDate.substring(0, 4)}` : "-"}{" "}
                  tarihinden{" "}
                  {formLeave.finishDate ? `${formLeave.finishDate.substring(8, 10)}/${formLeave.finishDate.substring(5, 7)}/${formLeave.finishDate.substring(0, 4)}` : "-"}{" "}
                  tarihine kadar{" "}
                  {formLeave?.isHalfDay && formLeave?.totalDate <= 1 && "yarım"}
                  {formLeave?.isHalfDay && formLeave?.totalDate > 1 && `${formLeave?.totalDate}.5`}
                  {formLeave?.isHalfDay === false && `${formLeave?.totalDate || "-"}`}{" "}
                  gün süreyle izine ayrılmak istiyorum.
                  <p className="text-right">Gereğini arz ederim.</p>
                </td>
              </tr>
              <tr>
                <td className="font-bold">Tarih :</td>
                <td className="border-l border-black">
                  {formLeave.currentDate
                    ? `${formLeave.currentDate.substring(8, 10)}/${formLeave.currentDate.substring(5, 7)}/${formLeave.currentDate.substring(0, 4)}`
                    : "-"}
                </td>
              </tr>
              <tr>
                <td className="h-[60px] font-bold">İzin İsteyenin İmzası</td>
                <td className="border-l border-black"></td>
              </tr>
            </tbody>
          </table>

          <p className="w-full max-w-[600px] pt-3 mx-auto indent-8 font-Arial">
            Bu izin yukarıda bahsedilen maksat için kullanılmadığı veya izin süresine uyulmadığı takdirde ilgili mevzuata göre cezalandırılacaktır.
          </p>
          <p className="w-full max-w-[600px] pb-3 mx-auto indent-8 font-Arial">
            Yukarıda belirtilen tarihler arası yine yukarıda belirtilen izin hakkı kullanılması işyerimizce uygun görülmüştür.
          </p>
          <div className="w-full max-w-[600px] mx-auto pb-7">
            <p className="text-sm pb-2 font-Arial-gd underline font-bold">İŞVERENİN:</p>
            <p className="font-Arial-gd font-bold">Adı Soyadı / Ünvanı :</p>
            <p className="font-Arial-gd font-bold">Tarih:</p>
            <p className="font-Arial-gd font-bold">Kaşe / İmza</p>
          </div>
        </div>
      </div>

      <div className="w-[600px] mx-auto flex justify-center gap-4 mt-6 print:hidden">
        <DownloadButton />
      </div>

      {formLeave?.comment && (
        <div className="w-[600px] flex flex-col justify-center py-10 print:hidden">
          <h1 className="font-arial-gd text-[15px]">İzin Alma Sebebi</h1>
          <span className="font-arial text-[12px]">{formLeave.comment}</span>
        </div>
      )}
    </div>
  );
}

export default Details;
